module.exports = {"341823100":"泾川镇","341823101":"茂林镇","341823102":"榔桥镇","341823103":"桃花潭镇","341823104":"琴溪镇","341823105":"蔡村镇","341823106":"云岭镇","341823107":"黄村镇","341823108":"丁家桥镇","341823200":"汀溪乡","341823201":"昌桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341823.json
// module id = 1156
// module chunks = 0